import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DirectoryComponent, LandingPageComponent } from '@sondermind/features/provider-profile-page';

const routes: Routes = [
  {
    path: '',
    component: DirectoryComponent,
  },
  {
    path: ':share_code',
    component: LandingPageComponent
  },
  {
    path: ':share_code/:name',
    component: LandingPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
